import {
  DeleteOutlineIcon,
  EditOutlinedIcon,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
  type MoreMenuIconButtonProps,
} from '@shared/components';
import { useMemo } from 'react';

import { useQConfigStructureModal } from '../../providers';

export interface LOSTableRowMenuProps extends Omit<MoreMenuIconButtonProps, 'options'> {
  qConfigStructureId: string;
  onUpdate: () => void;
}

export function LOSTableRowMenu(props: Readonly<LOSTableRowMenuProps>) {
  const { qConfigStructureId, onUpdate } = props;
  const { setAction } = useQConfigStructureModal();

  const handleDelete = () => {
    setAction({
      action: 'QCONFIG_DELETE',
      payload: { qConfigStructureId },
    });
  };

  const editOption: MoreMenuIconButtonOption = {
    icon: (
      <EditOutlinedIcon
        sx={{
          color: (theme) => theme.palette.grey[600],
        }}
      />
    ),
    label: 'Edit',
    onClick: onUpdate,
    sx: {
      ':hover': {
        backgroundColor: (theme) => theme.palette.primary.lighter,
      },
    },
  };

  const deleteOption: MoreMenuIconButtonOption = {
    icon: (
      <DeleteOutlineIcon
        sx={(theme) => ({
          color: theme.palette.error.main,
        })}
      />
    ),
    label: 'Delete',
    onClick: handleDelete,
    sx: (theme) => ({
      ':hover': {
        backgroundColor: theme.palette.primary.lighter,
      },
      color: theme.palette.error.main,
    }),
  };

  const losMenuOptions = useMemo(() => {
    const options = [];

    options.push(editOption);
    options.push(deleteOption);

    return options;
  }, [deleteOption, editOption]);

  return (
    <MoreMenuIconButton
      options={losMenuOptions}
      slotProps={{
        iconButton: {
          sx: {
            color: (theme) => theme.palette.grey[500],
          },
        },
      }}
    />
  );
}
